import React, { useState } from "react";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { switchState, deleteBenefit } from "./Axios";

const Hit = ({
               index, benefit, onEdit,
               onDeleteLocal, onUpdateLocal, notify
             })=>{
  const [checked,setChecked]=useState(benefit.aasm_state==="active");

  const toggle = ()=>{
    const fd=new FormData();
    fd.append("switch_state",checked?"deactivate":"activate");
    switchState(benefit.id,fd,res=>{
      if(res.status===200){
        setChecked(!checked);
        onUpdateLocal(res.data);
        notify("Genial","Estado actualizado","success");
      }else notify("Ops","No se pudo cambiar","danger");
    });
  };

  const del = ()=>{
    if(!window.confirm("¿Eliminar beneficio?")) return;
    deleteBenefit(benefit.id,res=>{
      if(res.status===200){
        onDeleteLocal(benefit.id);
        notify("Eliminado","Beneficio eliminado","success");
      }else notify("Error","No se pudo eliminar","danger");
    });
  };

  return(
    <tr>
      <td>{index}</td>
      <td>
        <strong>{benefit.title}</strong>
        <div className="small text-muted" dangerouslySetInnerHTML={{__html:benefit.content}}/>
      </td>
      <td>
        <Switch checked={checked} onChange={toggle} onColor="#00c851" offColor="#ff3547"/>
      </td>
      <td>
        <Button size="sm" color="primary" className="me-2" onClick={()=>onEdit(benefit)}>
          <i className="fas fa-edit"/>
        </Button>
        <Button size="sm" color="danger" onClick={del}>
          <i className="fas fa-trash"/>
        </Button>
      </td>
    </tr>
  );
};
export default Hit;
